import { asyncActionsMiddleware } from './middleware';

const middleware = [asyncActionsMiddleware];

export default middleware;
